import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getFromSettings, isAfterHours } from 'src/utils/helpers'

import NavBottom from './NavBottom'

import { openSidebar, closeSidebar, setCurrentlyOpenFeature } from 'src/modules/App/actions'

const mapStateToProps = (state) => {
  const afterHours = getFromSettings(state, 'afterHours')
  const timeZone = parseFloat(getFromSettings(state, 'timeZone', 0))

  return {
    chatUnreadCount: state.chat.unreadCount,
    isChatOnlyFeature: state.appReducer.isChatOnlyFeature,
    features: getFromSettings(state, 'features', {}),
    chatOptions: getFromSettings(state, 'chatOptions', {}),
    isAfterHours: isAfterHours(afterHours, timeZone),
    isChatEmpty: state.chat.isChatEmpty,
    areAppActionsDisabled: state.nonPersistentAppReducer.areAppActionsDisabled,
  }
}

const mapDispatchToProps = {
  openSidebar,
  closeSidebar,
  setCurrentlyOpenFeature,
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBottom))
